import { memo, useEffect, useState } from "react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useFormContext, useWatch } from "react-hook-form";
import { useRecoilValue } from "recoil";
import SearchBoxNew from "Components/formControls/HookFields/SearchBoxNew";
import { getCountries } from "Recoil/CompanySetup/selector";
import { useOrganizationValidation } from "Validations/Organization/useOrganizationValidation";
import { checkArrayLength } from "src/utils";
import { useOrganizationConstants } from "Hooks/organization/useOrganizationConstants";

const State = memo(() => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    clearErrors
  } = useFormContext();
  const countries = useRecoilValue(getCountries);
  const { information, disabledView } = useWatch();
  const { organizationStateError } = useOrganizationValidation();
  const { getStates } = useOrganizationConstants();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (checkArrayLength(countries) && information?.country?.value) {
      const states = getStates(countries, information?.country?.value);
      setOptions(
        states.map(state => {
          return { value: state?.name, name: state?.name };
        })
      );
    }
  }, [checkArrayLength(countries), information?.country?.value]);

  return (
    <SearchBoxNew
      register={register("information.state", organizationStateError)}
      name="information.state"
      label={t("companySetup.information.state.label")}
      placeholder={t("companySetup.information.state.placeholder")}
      error={get(errors, "information.state.message", "")}
      value={{ value: information?.state?.value }}
      menuList={options}
      clearError={() => clearErrors("information.state")}
      variant="outlined"
      disabled={disabledView}
    />
  );
});

export default State;
